import { render, staticRenderFns } from "./bankingInformation.vue?vue&type=template&id=f7030a96&"
import script from "./bankingInformation.vue?vue&type=script&lang=js&"
export * from "./bankingInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports